import { GridItem } from '../../../redux/queryResults/models';
import { ASC } from '../../../shared';
import {
  GRADE,
  YEAR,
  BLOCK,
  TYPE,
  CC,
  DIFFICULTY,
  QUESTION_ID,
  REGEX_ID_START,
  REGEX_ID_END} from './ListView.constants';
import { IOrderBy } from './ListView.interfaces';


export const gradeComparatorAsc = (a: GridItem, b: GridItem): number => {
  return a.gradeAsInt - b.gradeAsInt;
};

export const gradeComparatorDesc = (a: GridItem, b: GridItem): number => {
  return b.gradeAsInt - a.gradeAsInt;
};

export const yearComparatorAsc = (a: GridItem, b: GridItem): number => {
  return a.yearAsInt - b.yearAsInt;
};

export const yearComparatorDesc = (a: GridItem, b: GridItem): number => {
  return b.yearAsInt - a.yearAsInt;
};

// blockID = NumNumLetterNumNum
export const blockComparatorAsc = (a: GridItem, b: GridItem): number => {
  const indexA = a.blockID.search(REGEX_ID_START);
  const indexB = b.blockID.search(REGEX_ID_START);
  let result = a.blockID[indexA].localeCompare(b.blockID[indexB]);
  if (result === 0) {
    // look at sequence before letter
    try {
      const numA = +a.blockID.substring(0, indexA);
      const numB = +b.blockID.substring(0, indexB);
      result = numA - numB;

      if (result === 0) {
        // look at sequence after letter
        try {
          const numA = +a.blockID.substring(a.blockID.search(REGEX_ID_END) + 1);
          const numB = +b.blockID.substring(b.blockID.search(REGEX_ID_END) + 1);
          result = numA - numB;
        } catch {
          result = 0;
        }
      }
    } catch {
      result = 0;
    }
  }
  return result;
};

// blockID = NumNumLetterNumNum
export const blockComparatorDesc = (a: GridItem, b: GridItem): number => {
  const indexA = a.blockID.search(REGEX_ID_START);
  const indexB = b.blockID.search(REGEX_ID_START);
  let result = b.blockID[indexA].localeCompare(a.blockID[indexB]);
  if (result === 0) {
    // look at sequence before letter
    try {
      const numA = +a.blockID.substring(0, indexA);
      const numB = +b.blockID.substring(0, indexB);
      result = numB - numA;

      if (result === 0) {
        // look at sequence after letter
        try {
          const numA = +a.blockID.substring(a.blockID.search(REGEX_ID_END) + 1);
          const numB = +b.blockID.substring(b.blockID.search(REGEX_ID_END) + 1);
          result = numB - numA;
        } catch {
          result = 0;
        }
      }
    } catch {
      result = 0;
    }
  }
  return result;
};

export const typeComparatorAsc = (a: GridItem, b: GridItem): number => {
  return a.displayType.localeCompare(b.displayType);
};

export const typeComparatorDesc = (a: GridItem, b: GridItem): number => {
  return b.displayType.localeCompare(a.displayType);
};

export const ccComparatorAsc = (a: GridItem, b: GridItem): number => {
  return a.mainClassification.localeCompare(b.mainClassification);
};

export const ccComparatorDesc = (a: GridItem, b: GridItem): number => {
  return b.mainClassification.localeCompare(a.mainClassification);
};

export const dlComparatorAsc = (a: GridItem, b: GridItem): number => {
  return a.difficulty.localeCompare(b.difficulty);
};

export const dlComparatorDesc = (a: GridItem, b: GridItem): number => {
  return b.difficulty.localeCompare(a.difficulty);
};

export const questionIdComparatorAsc = (a: GridItem, b: GridItem): number => {
  const [stringA, numA] = a.questionID.split('#');
  const [stringB, numB] = b.questionID.split('#');
  const stringDiff = stringA.localeCompare(stringB);
  if (stringDiff === 0) {
    return +numA - +numB;
  } else {
    return stringDiff;
  }
};

export const questionIdComparatorDesc = (a: GridItem, b: GridItem): number => {
  const [stringA, numA] = a.questionID.split('#');
  const [stringB, numB] = b.questionID.split('#');
  const stringDiff = stringA.localeCompare(stringB);
  if (stringDiff === 0) {
    return +numB - +numA;
  } else {
    return stringDiff;
  }
};

export const abstractComparator = (sort: IOrderBy): ((a: GridItem, b: GridItem) => number) => {
  switch (sort.selected) {
  case GRADE:
    return sort.orderBy === ASC ?
      gradeComparatorAsc :
      gradeComparatorDesc;
  case YEAR:
    return sort.orderBy === ASC ?
      yearComparatorAsc :
      yearComparatorDesc;
  case BLOCK:
    return sort.orderBy === ASC ?
      blockComparatorAsc :
      blockComparatorDesc;
  case TYPE:
    return sort.orderBy === ASC ?
      typeComparatorAsc :
      typeComparatorDesc;
  case CC:
    return sort.orderBy === ASC ?
      ccComparatorAsc :
      ccComparatorDesc;
  case DIFFICULTY:
    return sort.orderBy === ASC ?
      dlComparatorAsc :
      dlComparatorDesc;
  case QUESTION_ID:
    return sort.orderBy === ASC ?
      questionIdComparatorAsc :
      questionIdComparatorDesc;
  default:
    return dlComparatorDesc;
  }
};

